import { createStore, setProps, withProps } from "@ngneat/elf";

import {ConfiguratorMode, ConfiguratorView, SelectionMode} from "~shared/enums";

import { ConfiguratorState } from "./configurator.types";

export function defaultPartConfiguratorState(): ConfiguratorState {
	return {
	// Configurator
		configuratorMode: ConfiguratorMode.PART,
		configuratorView: ConfiguratorView.PART_ITEM,
		selectionMode: null,
		fullscreen: false,
		activeDetailComponents: null,
		// Selection
		selectedItemId: null,
		selectedItemIds: [],
		selectedArticleId: null,
		selectedArticleZoneId: null,
		selectedArticleZoneIds: null,
		selectedPanelId: null,
		selectedFaceId: null,
		selectedFillerFaceIdx: null,
		// Visibility
		isolatedPanelId: null, // Double click on detail-panel
		panelsTransparent: false,
		frontsVisible: true,
		wallsVisible: true,
		flaggedPanelIds: [],
		highlightedFrameArticleId: null,
	}
}

export function defaultItemConfiguratorState(): ConfiguratorState {
	return {	// Configurator
		configuratorMode: ConfiguratorMode.ITEM,
		configuratorView: ConfiguratorView.PART_ITEM,
		selectionMode: SelectionMode.ARTICLE,
		fullscreen: false,
		activeDetailComponents: null,
		// Selection
		selectedItemId: null,
		selectedItemIds: [],
		selectedArticleId: null,
		selectedArticleZoneId: null,
		selectedArticleZoneIds: null,
		selectedPanelId: null,
		selectedFaceId: null,
		selectedFillerFaceIdx: null,
		// Visibility
		isolatedPanelId: null, // Double click on detail-panel
		panelsTransparent: false,
		frontsVisible: true,
		wallsVisible: true,
		flaggedPanelIds: [],
		highlightedFrameArticleId: null,
	}
}


export const configuratorStore = createStore(
	{ name: 'configurator' },
	withProps<ConfiguratorState>(
		defaultPartConfiguratorState()
	)
)


/** Flag panels for a while - the scene glows them - for as long as an error toast is
 *  up, say. A later flag replaces an earlier one; only its own timer clears it. */
export function flagPanels(panelIds: string[], durationMs: number): void {
	configuratorStore.update(setProps({ flaggedPanelIds: panelIds }));
	setTimeout(() => {
		if (configuratorStore.query((state) => state.flaggedPanelIds) === panelIds) {
			configuratorStore.update(setProps({ flaggedPanelIds: [] }));
		}
	}, durationMs);
}
